import React, { useEffect } from 'react';

const PopupComp = ({ children, onClose }) => {
  useEffect(() => {
    // Lock scroll
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = 'unset'; };
  }, []);

  return (
    <div
      id="popup-backdrop"
      onClick={(e) => e.target.id === 'popup-backdrop' && onClose()}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 sm:p-6"
    >
      {/* This container ensures the card stays centered and doesn't stretch to 100% height */}
      <div className="w-full max-w-lg animate-in zoom-in-95 duration-200">
        {children}
      </div>
    </div>
  );
};

export default PopupComp;